import React from 'react'
import axios from "axios";
import NavFormProfile from './NavFormProfile';
import Path from "./config";
import AdminNavFormProfile from './AdminNavFormProfile';

class EducationInfo extends React.Component {

    constructor(props) {
        super(props);
        //for radio onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {
            education: [],
            sbg_education_id: '',
            sbg_other_education: '',
            showMe: "",
            NavMenu: false,
            apekshaLength: '0',
        }
    }



    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }

        axios.get(Path + 'Suchi_bride_groom_eduinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;
                if (response.sbg_education_id === "42") {
                    this.setState({ showMe: true })
                }
                this.setState({
                    sbg_education_id: response.sbg_education_id,

                    sbg_edu_specialization: response.sbg_edu_specialization,
                    apekshaLength: response.sbg_edu_specialization.length,
                })
            }.bind(this))




        // ********************** education ************************
        axios.get(Path + 'suchi_eduDegreeList.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ education: response.data.bg_edu_degree })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });

    }

    eduHandler = (e) => {

        document.getElementById("sbg_education_id").style.borderColor = "";
        this.setState({ sbg_education_id: e.target.value, }



        )
    }


    specialHandler = (e) => {
        let data = e.target.value;
        if (data.length > 100) {

        }
        else {
            this.setState({ sbg_edu_specialization: e.target.value, apekshaLength: data.length });
        }
    }


    submitClick = (e) => {
        // console.log(" Name=",this.state.sbg_education_id);
        //console.log("Email=",this.state.sbg_email_id);
        let isValid = true;
        if (this.state.sbg_education_id === "f" || this.state.sbg_education_id === "0") {
            document.getElementById("sbg_education_id").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_edu_specialization === "") {
            document.getElementById("sbg_edu_specialization").style.borderColor = "red";
            isValid = false;
        }


        e.preventDefault();

        //let sbg_birth_date= this.state.sbg_birth_year+"-"+this.state.sbg_birth_month+"-"+this.state.sbg_birth_date;
        //let sbg_birth_time= this.state.sbg_birth_time+" "+this.state.sbg_birth_am;
        let typee = "education";
        let tempStr = "sbg_education_id=" + this.state.sbg_education_id +
            "&sbg_edu_specialization=" + this.state.sbg_edu_specialization +
            "&sbg_id=" + this.state.userId +
            "&type=" + typee


        //console.log(tempStr)
        if (isValid === true) {
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);


                    if (response.data.status === "updated") {
                        // localStorage.setItem("userId",response.data.sbg_id)
                        if (this.state.admin === "Admin") {
                            this.props.history.push(`/AdminProfile/IncomeInfo`);
                        }
                        else {
                            this.props.history.push(`/FormProfile/IncomeInfo`);
                        }

                    }
                    // alert("Updated Successfully");


                }.bind(this))
        }
        else { document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी."; }

    }

    render() {


        let educationList = this.state.education.map((relation, index) => {
            const { bed_id, e_bed_degree } = relation //destructuring
            return (

                <option key={bed_id} value={bed_id} > {e_bed_degree} </option>

            )
        })



        return (


            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    {/* <span className="pt-3 mx-auto" >वैयक्तिक माहिती </span> */}
                    <form className="row g-3">
                        <p className="text-primary">
                            {/* // शिक्षण टीप :- या ठिकाणी आपले शिक्षण नसल्यास आपण 'यापैकी नाही' ही सिलेक्ट करावे आणि पुढील बॉक्स मध्ये आपली शैक्षणिक माहिती भरावी  */}
                        </p>
                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label">* तुमच्या सर्वोच्च शिक्षणाची कॅटेगिरी निवडणे गरजेचे आहे  </label>
                            <select id="sbg_education_id" className="form-select" value={this.state.sbg_education_id} onChange={this.eduHandler} >
                                <option value="f">Choose...</option>
                                {educationList}
                            </select>
                        </div>


                        <div className="col-md-8">
                            <label for="inputEmail4" className="form-label">* तुमचे सर्व महत्वाचे शिक्षण खालील बॉक्समध्ये लिहावे   </label>
                            <textarea className="form-control" value={this.state.sbg_edu_specialization} onChange={this.specialHandler} id="sbg_edu_specialization" />
                            <span id="dataLimit"></span><span>{this.state.apekshaLength}/100</span>
                        </div>
                        <div className="col-12">

                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                            <br></br>
                            <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                        </div>
                    </form>
                </div>
            </>
        )
    }
}

export default EducationInfo

